import { render, staticRenderFns } from "./SpatialSpan.vue?vue&type=template&id=1436a8fc&scoped=true&"
import script from "./SpatialSpan.vue?vue&type=script&lang=js&"
export * from "./SpatialSpan.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpan.vue?vue&type=style&index=0&id=1436a8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436a8fc",
  null
  
)

export default component.exports